import moment from "moment";

const columns = [
  {
    name: "Created At",
    selector: "createdAt",
    width: "250px",
    cell: (row) => {
      return moment(row.createdAt).format("llll");
    },
  },
  {
    name: "Departure Airport",
    selector: "departureAirportName",
    width: "300px",
  },
  {
    name: "Arrival Airport",
    selector: "arrivalAirportName",
    width: "300px",
  },
  {
    name: "Departure Date",
    selector: "departureDate",
    width: "150px",
  },
  {
    name: "Return Date",
    selector: "returnDate",
    width: "150px",
  },
  {
    name: "Pax",
    selector: "passengerCount",
    width: "150px",
  },
  {
    name: "Trip Type",
    selector: "tripType",
    width: "150px",
    cell: (row) => (row.tripType === 1 ? "One Way" : "Round Trip"),
  },

  {
    name: "Origin",
    selector: "origin",
    sortable: true,
    width: "150px",
    cell: (row) => {
      let formatted = "";
      if (row.origin === "qfs") {
        formatted = "Flight Deck - QFS";
      } else if (row.origin === "liveAPI") {
        formatted = "Live API";
      } else if (row.origin === "phoneCall") {
        formatted = "Phone Call";
      } else if (row.origin === "flightDeckInternal") {
        formatted = "Flight Deck - Internal";
      } else if (row.origin === "flightDeckExternal") {
        formatted = "Flight Deck - External";
      } else if (row.origin === "apiV3") {
        formatted = "Outside Org API";
      } else if (row.origin === "iosApp") {
        formatted = "iOS App";
      } else {
        formatted = "Unset";
      }

      return formatted;
    },
  },
];

export default columns;
